<template>
  <div>
    <Dialog :show="cancelDialogVisible" @close="$event => closeDialog()">
      <div class="dialog-box">
        <h2>{{ cancelButton?.pop_up_text?.title || 'Are You Sure You Want to Cancel?' }}</h2>
        <p>{{ cancelButton?.pop_up_text?.description || 'You\'re about to cancel your application. Any progress you\'ve made so far will be lost. Do you want to continue?' }}</p>
        <div class="dialog-buttons">
          <button class="cancel-button" @click="$event => closeDialog()">{{ cancelButton?.pop_up_text?.no || 'Cancel' }}</button>
          <button class="confirm-button" @click="$event => cancelToTransitionPage()">
            <span>{{ cancelButton?.pop_up_text?.yes || 'Yes' }}</span>
          </button>
        </div>
      </div>
    </Dialog>
    <div class="d-md-flex justify-content-md-end grid-container">
      <button class="btn btn-egx" @click="prevButtonFlow" v-if="displayPrevious">
        Previous
      </button>
      <button class="btn btn-egx" @click="cancelButtonFlow">
        {{this.stepsResponse['cancel_btn_lbl'] || this.cancelButton?.label || 'Cancel'}}
      </button>
      <button class="btn btn-egx" @click="saveChangesButtonFlow" v-if="displaySaveChangesBtn">
        {{this.saveChangesButton?.label || 'Save Changes'}}
      </button>
      <button class="btn btn-egx" @click="addButtonFlow" v-if="this.stepsResponse.add_btn_url">
        {{this.stepsResponse['add_btn_label'] || 'Save &amp; Return to My Applications Page'}}
      </button>
      <button class="btn btn-egx" @click="nextStepFlow">
        {{this.stepsResponse['next_btn_label'] || 'Save &amp; Next Step'}}
      </button>
    </div>
  </div>
</template>

<script>
import redirectPath from '@/shared/mixins/redirect-path';
import Dialog from '@/components/Dialog.vue';

export default {
  components: { Dialog },
  props: {
    stepsResponse: {
      type: Object,
      default: {},
    },
    dataSaveRequired: false,
    displaySaveChangesBtn: false,
  },

  mixins: [redirectPath],

  data() {
    return {
      cancelDialogVisible: false
    }
  },

  computed: {
    displayPrevious(){
      return this.stepsResponse.hide_prev_btn === 'false' && Number(this.stepsResponse.step_num) > 1;
    },

    fulfillSyncDetails() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details;
    },

    portalStepPageSetup() {
      return this.fulfillSyncDetails?.pages?.portal_steps;
    },

    cancelButton() {
      return this.portalStepPageSetup?.cancel_button;
    },

    saveChangesButton() {
      return this.portalStepPageSetup?.save_changes_button;
    },

    currentSelectedProject() {
      return this.$store.state.fulfill_integrate.currentSelectedProject;
    },
  },

  methods: {
    prevButtonFlow(){
      this.$emit('navigate', 'ps');
    },

    nextStepFlow(){
      if (this.dataSaveRequired){
        this.$emit('save-data', 'nextStep');
      } else {
        this.$emit('navigate', 'ns');
      }
    },

    addButtonFlow(){
      // if (this.dataSaveRequired){ this.$emit('save-data', 'linkStep'); }
      this.redirectPath(this.stepsResponse.add_btn_url);
    },

    cancelButtonFlow(){
      if (this.fulfillSyncDetails?.allow_transition_page_for_steps) {
        this.cancelDialogVisible = true;
      } else {
        this.redirectPath(this.stepsResponse.cancel_btn_url || this.cancelButton?.url || '/applications');
      }
    },

    cancelToTransitionPage() {
      const that = this;
      this.$store.dispatch('auth/signOut').then(() => {
        const event = new CustomEvent('applicationEvent', {
          detail: { projectAction: 'cancel', projectId: that.currentSelectedProject.id },
          bubbles: true,
          cancelable: false,
        })
        window.parent.document.dispatchEvent(event);
        this.$router.push('/please-wait?mode=cancel');
      });
    },

    saveChangesButtonFlow(){
      this.$emit('save-data', 'saveChanges');
    },

    closeDialog() {
      this.cancelDialogVisible = false;
    },
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/components/project/confirm-dialog.scss';
.grid-container {
  display: grid;
  grid-auto-rows: auto;
  transform: rotate(180deg);
  direction: rtl;
  column-gap: 20px;
}

.grid-container > * {
  transform: rotate(180deg);
  margin-right: 0;
  margin-bottom: 15px;
}
</style>
